<div class="map-marker-item-container" [attr.data-test-id]="'marker-info-' + index">
  <div class="pb-2 d-flex w-100 justify-content-center">
    <app-small-profile-image
      [profileImage]="data.user.image"
      [accountStatus]="data.user.status"
      [dataTestId]="'user-image-' + index"
      [width]="42"
      [height]="42"
      [fontSize]="'0.4rem'"
      [link]="getLink(data.user)"
      [accessForAdmin]="isAdminSession"
      [openInNewWindow]="true"
    ></app-small-profile-image>
  </div>
  <h5>
    <app-profile-link
      [dataTestId]="'user-username-' + index"
      [cssStyles]="'username'"
      [status]="data.user.status"
      [userId]="data.user.userId"
      [text]="data.user.displayedName"
      [openInNewWindow]="true"
    ></app-profile-link>
  </h5>
  <h5 *ngIf="data.user.role" [attr.data-test-id]="'data-role-' + index">
    {{ data.user.role | translate }}
  </h5>
  <h5 *ngIf="data?.specialization?.length" [attr.data-test-id]="'data-specialization-' + index">
    {{ data.specialization | formatCategories }}
  </h5>
  <h6 [attr.data-test-id]="'data-location-' + index" [innerHtml]="data.displayedLocation"></h6>
</div>
